import { ExcludedMaterial } from 'Components/Worksheets/Core/Fields';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { pipe } from 'Lib/Hooks/Selectors';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import deepEquals from '../../../../../Lib/Object/deepEquals';
import { Button, Dropdown, Field, NumericInput, RadioGroup, TextOutput } from '../../../../Core';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { FieldSet, ListFieldSection } from '../../../../Layout';
import { WorksheetEquipmentDropdown } from '../../../Core';
import { WorksheetBalanceFieldSet } from '../../../Core/WorksheetEquipment';

let AstmPreparationSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const [testConditionsEditable, setTestConditionsEditable] = useState(false);
  const method = useSelector(createWorksheetSelector!('Preparation.Method'));
  const methodOptions = [
    { label: 'A - Nearest 1%', value: 'A' },
    { label: 'B - Nearest 0.1%', value: 'B' },
  ];
  const selectedMethod = methodOptions.find((o: any) => o.value === method);
  const visualNominalParticleSizeSieveOptions = useSelector(
    pipe(createWorksheetSelector!('Preparation.AllVisualNominalParticleSizeSieves'), (ss) =>
      (ss || []).map((s: any) => ({
        value: s.Id,
        label: s.Caption,
      }))
    ),
    deepEquals
  );
  const visualNominalParticleSize = useSelector(createWorksheetSelector!('Preparation.VisualNominalParticleSize'));
  const selectedVisualNominalParticleSizeSieveOption = visualNominalParticleSizeSieveOptions.find(
    (o: any) => o.value === visualNominalParticleSize
  );

  return (
    <>
      {/* Editable fields */}
      <ListFieldSection visible={testConditionsEditable}>
        <FieldSet>
          <Field input={<RadioGroup />} name="Preparation.Method" options={methodOptions} />
        </FieldSet>
        <FieldSet>
          <Field
            input={<Dropdown />}
            name="Preparation.VisualNominalParticleSize"
            options={visualNominalParticleSizeSieveOptions}
            simpleValue
          />
        </FieldSet>
        <FieldSet>
          <Field input={<NumericInput />} name="Equipment.DryingTemperature" />
        </FieldSet>

        <ExcludedMaterial editable appendNamePrefix="Preparation" />
      </ListFieldSection>
      {/* Read-only fields */}
      <ListFieldSection visible={!testConditionsEditable}>
        <Field
          emph
          input={<TextOutput />}
          name="Preparation.Method"
          value={selectedMethod ? selectedMethod.label : null}
        />
        <Field
          emph
          input={<TextOutput />}
          name="Preparation.VisualNominalParticleSize"
          value={
            selectedVisualNominalParticleSizeSieveOption ? selectedVisualNominalParticleSizeSieveOption.label : null
          }
        />
        <Field emph input={<TextOutput />} name="Equipment.DryingTemperature" />
        <ExcludedMaterial readOnlyDefaultText="None" appendNamePrefix="Preparation" />
        <div>
          <Button
            onClick={() => {
              setTestConditionsEditable(true);
            }}
          >
            Change
          </Button>
        </div>
      </ListFieldSection>
      <ListFieldSection>
        <WorksheetBalanceFieldSet name="Equipment.Balance" />
        <FieldSet>
          <Field input={<WorksheetEquipmentDropdown />} equipmentType="oven" name="Equipment.Oven" />
        </FieldSet>
      </ListFieldSection>
    </>
  );
};

AstmPreparationSection = withInjectedProps(AstmPreparationSection);

export { AstmPreparationSection };
export default AstmPreparationSection;
